import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Card,
  Grid,
  Divider,
  Switch,
  Button,
  LinearProgress
} from '@material-ui/core';
import { Breadcrumb } from 'components';
import { getStoreConfigsApi, updateStoreConfigsApi } from 'api';
import { changeStoreConfig } from 'redux/actions/store_configs';


export default function CompareConf() {
  const dispatch = useDispatch();

  const {storeConfigs, loading, error} = useSelector((state) => state.store_configs);

  useEffect(() => {
    if (storeConfigs.length === 0) {
      getStoreConfigsApi({dispatch});
    }
  }, []);

  const handleChange = (event) => {
    const {name, checked, type, value} = event.target;
    dispatch(changeStoreConfig(name, checked, type, value));
  };

  const handleSave = () => {
    const configs = storeConfigs.filter((config) => config.path === 'store_info/compare_configuration/is_enable');
    updateStoreConfigsApi({dispatch, configs});
  };

  return (
    <div className="flex-grow flex-column relative h-full scroll-y">
      <div>
        <Breadcrumb
          routeSegments={[
            { name: 'Settings', path: '/settings#go_live_requirements' },
            { name: 'Store Configurations', path: '/settings#store_configurations' },
            { name: 'Compare List' }
          ]}
        />
      </div>
      <div className="mt-10 mx-10">
        <Card className="p-8">
          {loading && <LinearProgress className="m-10" />}
          {!loading && error && <div className="m-10">Can&apos;t fetch Shipping data</div>}
          {!loading && storeConfigs.length !== 0 &&
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <p className="text-gray">In this section you can allow or disallow customers add products into compare list on your store</p>
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid item xs={6}>
              Enable Adding Products to Compare List:
            </Grid>
            <Grid item xs={6}>
              <Switch
                color="primary"
                name="store_info/compare_configuration/is_enable"
                checked={storeConfigs.find((config) => config.path === 'store_info/compare_configuration/is_enable').value == 1}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} className="flex justify-end">
              <Button variant="contained" color="primary" className="my-10" onClick={handleSave}>Save Configurations</Button>
            </Grid>
          </Grid>
          }
        </Card>
      </div>
    </div>
  );
}
